import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';
import { map } from 'rxjs/operators';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

class NscIndicatePartnerRequest {
}

class NscIndicatePartnerResponse {
}

var BenefitEnum;
(function (BenefitEnum) {
    BenefitEnum["BENEFIT"] = "BENEFIT";
    BenefitEnum["NO_BENEFIT"] = "NO_BENEFIT";
})(BenefitEnum || (BenefitEnum = {}));

var AddressType;
(function (AddressType) {
    AddressType["PHYSIC"] = "f\u00EDsico";
    AddressType["SITE"] = "online";
})(AddressType || (AddressType = {}));

var TransactionType;
(function (TransactionType) {
    TransactionType["DEBIT"] = "DEBIT";
    TransactionType["CREDIT"] = "CREDIT";
})(TransactionType || (TransactionType = {}));

var QrcodeType;
(function (QrcodeType) {
    QrcodeType["NSC"] = "CLUBE_NSC";
})(QrcodeType || (QrcodeType = {}));

var StatusQrcode;
(function (StatusQrcode) {
    StatusQrcode["PAID_OUT"] = "PAID_OUT";
    StatusQrcode["NOT_PAY"] = "NOT_PAY";
})(StatusQrcode || (StatusQrcode = {}));

//MUDAR QUANDO ESTIVER PRONTO! (NOME TEMPORARIO!!!!!!!!)
const SPE_NSC = '/spe-nsc';
let SpeNscProxy = class SpeNscProxy {
};
SpeNscProxy = __decorate([
    Injectable()
], SpeNscProxy);

const SPE_VIEW_N_ACCOUNT = '/spe-n-user-account';
let SpeNUserAccountProxy = class SpeNUserAccountProxy {
    constructor(api) {
        this.api = api;
    }
    insertData(user) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/`;
        user.typeFlow = 'CLUB_NSC';
        return this.api.post(uri, user);
    }
    updateData(user) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/pre-account/${user._id}`;
        return this.api.put(uri, user);
    }
};
SpeNUserAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNUserAccountProxy = __decorate([
    Injectable()
], SpeNUserAccountProxy);

const SPE_VIEW_N_ACCOUNT$1 = '/spe-view-n-user-account';
let SpeViewNUserAccountProxy = class SpeViewNUserAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getUserData(id) {
        const uri = `${SPE_VIEW_N_ACCOUNT$1}/v1/find-by-id/${id}`;
        return this.api.get(uri);
    }
    getUserDataByWlpAndPayment(wlpUuid, paymentUuid) {
        const uri = `${SPE_VIEW_N_ACCOUNT$1}/v1/pre-user-account/white-label/${wlpUuid}/account-payment/${paymentUuid}`;
        return this.api.get(uri);
    }
    checkUserEmail(uuidWhiteLabel, email) {
        const uri = `${SPE_VIEW_N_ACCOUNT$1}/v1/verification-email/${email}/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    findDocumentIsUsed(uuidWhiteLabel, verify) {
        const uri = `${SPE_VIEW_N_ACCOUNT$1}/v1/verify-document/white-label/${uuidWhiteLabel}`;
        return this.api.post(uri, verify);
    }
};
SpeViewNUserAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNUserAccountProxy = __decorate([
    Injectable()
], SpeViewNUserAccountProxy);

const SPE_VIEW_N_VOUNCHER_CLUB_NSC = '/spe-view-n-voucher-club-nsc';
let SpeViewNVouncherClubNscProxy = class SpeViewNVouncherClubNscProxy {
    constructor(api) {
        this.api = api;
    }
    getAllCategories() {
        const defaultFilter = { uuidAccountPayment: '', filters: { showApp: true } };
        return this.api.post(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/category/show-app-all`, defaultFilter);
    }
    getBanners() {
        return this.api.post(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/banner/all`, {});
    }
    /**
     * busca os cards por meio de um filtro e limite de cards
     * @param filter
     * @param limit
     * @returns Observable<NscCard>
     */
    findCards(filter, limit, sort) {
        const options = { skip: 0, limit: limit };
        const defaultFilter = { filters: filter, options: options };
        // caso setar a busca por filtragem
        if (sort === true) {
            options['sort'] = 'shelfLifeEnd';
        }
        return this.api.post(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/discount/by-partner`, defaultFilter);
    }
    /**
   * busca os cards por meio de um filtro e limite de cards
   * @param filter
   * @param limit
   * @returns Observable<NscCard>
   */
    findCard(filter, limit) {
        const options = { skip: 0, limit: limit };
        const defaultFilter = { filters: filter, options: options };
        return this.api.post(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/discount`, defaultFilter);
    }
    /**
     * busca os cards em destaques
     * @param filter
     * @param limit
     * @returns Observable<NscCard>
     */
    findHighlightsCards(filter, limit) {
        const options = { skip: 0, limit: limit };
        const defaultFilter = { filters: filter, options: options };
        return this.api.post(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/discount/by-partner`, defaultFilter);
    }
    /**
     * busca os cards acontecendo dos proximos dias
     * @returns Observable<NscCardResult>
     */
    findEventCards(filter, limit) {
        const options = { skip: 0, limit: limit };
        const defaultFilter = { filters: filter, options: options };
        return this.api.post(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/discount/event/next-day`, defaultFilter);
    }
    /**
   * busca os cards usage locations
   * @param filter
   * @param limit
   * @returns Observable<NscCard>
   */
    findUsageLocations(filter, limit) {
        const options = { skip: 0, limit: limit };
        const defaultFilter = { filters: filter, options: options };
        return this.api.post(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/discount/usage-locations`, defaultFilter);
    }
    /**
    * busca os branchs a partir do _id
    * @param filter
    * @returns Observable<NscCouponUsage>
    */
    findBranchs(filter) {
        const defaultFilter = {
            filters: {
                _id: filter
            }
        };
        return this.api.post(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/branch/list`, defaultFilter);
    }
    /**
     * retorna os dados de transaction do ususario
     * @param uuidAccountPayment
     * @returns
     */
    findTransactions(uuidAccountPayment) {
        return this.api.get(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/payment/resume/account/${uuidAccountPayment}`);
    }
    findCouponByUser(userUuid) {
        const filter = {
            filters: {
                userId: userUuid
            }
        };
        return this.api.post(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/coupon/by-user`, filter);
    }
    findCoupon(couponUuuid) {
        const filter = {
            filters: {
                _id: couponUuuid,
            }
        };
        return this.api.post(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/one-coupon`, filter);
    }
    findPartner(document) {
        const documentUnmasked = document.replace(/\.|\/|\-/g, '');
        const filter = {
            filters: {
                document: documentUnmasked
            }
        };
        return this.api.post(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/partner`, filter);
    }
    /**
     * checa se o usuario ja existe como um partner na nossa base
     * @param uuidAccountPayment
     * @returns Observer
     */
    checkPartnerExists(uuidAccountPayment) {
        return this.api.get(`${SPE_VIEW_N_VOUNCHER_CLUB_NSC}/v1/find/partner/onboarding-ec/${uuidAccountPayment}`)
            .pipe(map(res => {
            if (res.status === true)
                return true;
            return false;
        }));
    }
};
SpeViewNVouncherClubNscProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNVouncherClubNscProxy = __decorate([
    Injectable()
], SpeViewNVouncherClubNscProxy);

const SPE_VIEW_N_ACCOUNT$2 = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getWallets(uuidWhiteLabel, uuidAccount) {
        const uri = `${SPE_VIEW_N_ACCOUNT$2}/v1/wallets/ap/${uuidAccount}/wl/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNAccountProxy = __decorate([
    Injectable()
], SpeViewNAccountProxy);

const SPE_N_VOUNCHER_CLUB_NSC = '/spe-n-voucher-club-nsc';
let SpeNVouncherClubNscProxy = class SpeNVouncherClubNscProxy {
    constructor(api) {
        this.api = api;
    }
    /**
     * executa o pagamento
     * @returns
     */
    payment(payment) {
        return this.api.post(`${SPE_N_VOUNCHER_CLUB_NSC}/v1/payment`, payment);
    }
    /**
     * atualiza o qrcode
     * @returns
    */
    updateQrcode(user) {
        const uri = `${SPE_N_VOUNCHER_CLUB_NSC}/v1/qrcode/`;
        return this.api.put(uri, user);
    }
    /**
     * criacao de coupon
     * @param request
     * @returns
     */
    createCoupon(request) {
        return this.api.post(`${SPE_N_VOUNCHER_CLUB_NSC}/v1/create/coupon`, request);
    }
    /**
     * indica o parceiro
     * @param request
     * @returns
     */
    indicatePartner(request) {
        return this.api.post(`${SPE_N_VOUNCHER_CLUB_NSC}/v1/indicate/partner`, request);
    }
};
SpeNVouncherClubNscProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNVouncherClubNscProxy = __decorate([
    Injectable()
], SpeNVouncherClubNscProxy);

const SPE_N_ACCOUNTS = '/spe-n-accounts';
let SpeNAccountsProxy = class SpeNAccountsProxy {
    constructor(api) {
        this.api = api;
    }
    /**
   * @returns Observable<any>
   */
    decodeQrcode(request) {
        return this.api.post(`${SPE_N_ACCOUNTS}/v1/decode-qr-onus`, request);
    }
    /**
   * @returns Observable<any>
   */
    generateQrcode(request) {
        return this.api.post(`${SPE_N_ACCOUNTS}/v1/generate-qr-onus`, request);
    }
    /**
  * @returns Observable<any>
  */
    statusQrcode(encode) {
        return this.api.post(`${SPE_N_ACCOUNTS}/v1/status-qr-onus/${encode}`);
    }
    applyPartner(partner) {
        return this.api.post(`${SPE_N_ACCOUNTS}/v1/product-request/nsc-co-partner`, partner);
    }
};
SpeNAccountsProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNAccountsProxy = __decorate([
    Injectable()
], SpeNAccountsProxy);

let UiPxNscModule = class UiPxNscModule {
};
UiPxNscModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            ConfigService,
            SpeNUserAccountProxy,
            SpeViewNUserAccountProxy,
            SpeViewNVouncherClubNscProxy,
            SpeViewNAccountProxy,
            SpeNVouncherClubNscProxy,
            SpeNAccountsProxy
        ]
    })
], UiPxNscModule);

/*
 * Public API Surface of ui-px-nsc
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddressType, BenefitEnum, ConfigService, NscIndicatePartnerRequest, NscIndicatePartnerResponse, QrcodeType, SpeNAccountsProxy, SpeNUserAccountProxy, SpeNVouncherClubNscProxy, SpeNscProxy, SpeViewNAccountProxy, SpeViewNUserAccountProxy, SpeViewNVouncherClubNscProxy, StatusQrcode, TransactionType, UiPxNscModule };
//# sourceMappingURL=wlp-ui-px-nsc.js.map
